// extracted by mini-css-extract-plugin
export default {"root":"TitleCard_root__4jgYv","container":"TitleCard_container__QMt8s","title":"TitleCard_title__3B8C1","content":"TitleCard_content__PRDDG"};